export enum TalentQuickFilterButton {
  OWN_NEW = "OWN_NEW",
  TEAM_NEW = "TEAM_NEW",
  OWN_ENDING_SOON = "OWN_ENDING_SOON",
  TEAM_ENDING_SOON = "TEAM_ENDING_SOON",
  EMPTY = "",
}

export interface DashboardTalentCounts {
  talentsAssignedToMeCount: number;
  teamsNewTalentCount: number;
  talEmpEndingSoonAssignedToMeCount: number;
  talEmpEndingSoonAssignedToTeamCount: number;
}
